// Slow, continuous gliding. Pause for reading, touch, keyboard, and reduced motion.
const receipts = document.querySelector('#receipts-track');
const pauseButton = document.querySelector('.receipt-pause');
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
let userPaused = reduceMotion.matches;
let hovering = false;
let touching = false;
let visible = false;
let direction = 1;
let position = 0;
let previousFrame = 0;
let resumeAfter = 0;

function syncPauseButton() {
  pauseButton.textContent = userPaused ? 'Play slider' : 'Pause slider';
  pauseButton.setAttribute('aria-pressed', String(userPaused));
}

function rest() {
  resumeAfter = performance.now() + 6000;
  position = receipts.scrollLeft;
}

function moveCard(step) {
  rest();
  const cardWidth = receipts.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(receipts).gap);
  receipts.scrollBy({
    left: step * cardWidth,
    behavior: reduceMotion.matches ? 'instant' : 'smooth'
  });
}

pauseButton.addEventListener('click', () => {
  userPaused = !userPaused;
  syncPauseButton();
});

reduceMotion.addEventListener('change', event => {
  userPaused = event.matches;
  syncPauseButton();
});

receipts.addEventListener('pointerenter', event => {
  if (event.pointerType === 'mouse') hovering = true;
});

receipts.addEventListener('pointerleave', () => {
  hovering = false;
});

receipts.addEventListener('pointerdown', () => {
  touching = true;
  rest();
});

window.addEventListener('pointerup', () => {
  if (touching) {
    touching = false;
    rest();
  }
});

window.addEventListener('pointercancel', () => {
  touching = false;
  rest();
});

receipts.addEventListener('wheel', rest, {passive: true});

receipts.addEventListener('scroll', () => {
  if (touching || performance.now() < resumeAfter) {
    position = receipts.scrollLeft;
  }
}, {passive: true});

receipts.addEventListener('keydown', event => {
  if (event.target === receipts && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
    event.preventDefault();
    moveCard(event.key === 'ArrowRight' ? 1 : -1);
  }
});

document.querySelectorAll('[data-receipt-step]').forEach(button => {
  button.addEventListener('click', () => {
    moveCard(Number(button.dataset.receiptStep));
  });
});

new IntersectionObserver(entries => {
  visible = entries[0].isIntersecting;
}, {threshold: .15}).observe(receipts);

function glide(now) {
  const seconds = previousFrame ? Math.min((now - previousFrame) / 1000, .08) : 0;
  previousFrame = now;
  const max = Math.max(0, receipts.scrollWidth - receipts.clientWidth);
  const moving = !userPaused &&
    !hovering &&
    !touching &&
    !receipts.contains(document.activeElement) &&
    visible &&
    !document.hidden &&
    now >= resumeAfter &&
    max > 0;

  receipts.dataset.motion = moving ? 'gliding' : 'paused';

  if (moving) {
    position += direction * 18 * seconds;

    if (position >= max) {
      position = max;
      direction = -1;
    }

    if (position <= 0) {
      position = 0;
      direction = 1;
    }

    receipts.scrollLeft = position;
  } else {
    position = receipts.scrollLeft;
  }

  requestAnimationFrame(glide);
}

syncPauseButton();
requestAnimationFrame(glide);

// Only one clip plays at once; leaving the section stops playback.
const videos = [...document.querySelectorAll('.creator-clips video')];

videos.forEach(video => {
  video.addEventListener('play', () => {
    videos.forEach(other => {
      if (other !== video) other.pause();
    });
  });
});

const playbackObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) entry.target.pause();
  });
}, {threshold: 0});

videos.forEach(video => playbackObserver.observe(video));

document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    videos.forEach(video => video.pause());
  }
});
